import * as CryptoJs from 'crypto-js';

export const crypt = {
    base64VerifierHash: (codeVerifier: string): string => {
        const codeVerifierHash = CryptoJs.SHA256(codeVerifier);
        return CryptoJs.enc.Base64.stringify(codeVerifierHash).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    },

};


